export default {
    // get logged user state
    currentUser: state => {
        return state.AppActiveUser && state.AppActiveUser.id ? state.AppActiveUser : false;
    },

    // get logged user state
    checkCurrentUserID: state => (id) => {

        // Check is incoming parameter array
        if (!Array.isArray(id)) id = [id];

        // Check is current user in the list
        return id.includes(state.AppActiveUser.id);
    },

    /**
     * get logged user state
     * @param state
     * @returns {function(*=): boolean}
     */
    checkCurrentUserInList: state => (id) => {

        // Check is incoming parameter array
        if (!Array.isArray(id)) id = [id];

        // Check is current user in the list
        return id.map((u) => {
            return u ? u.id : 0;
        }).includes(state.AppActiveUser.id);
    },

    /**
     * get logged user role
     * @param state
     * @returns {function(*=): boolean}
     */
    checkCurrentRoleInList: state => (id) => {

        // Check is incoming parameter array
        if (!Array.isArray(id)) id = [id];

        // Check is current user in the list
        return state.AppActiveUser.roles.filter( (role) => id.includes(role)).length ? 1 : 0;
    },

    /**
     * get logged positions role
     * @param state
     * @returns {function(*=): boolean}
     */
    checkCurrentPositionInList: state => (id) => {

        // Check is incoming parameter array
        if (!Array.isArray(id)) id = [id];

        // Check is current user in the list
        return state.AppActiveUser.positions.filter( (pos) => id.map((u) => {return u && u.id}).includes(pos) ? true : false).length ? 1 : 0;
    },

    /**
     * Check for role
     * @param state
     * @returns {Function}
     */
    checkRole: state => (role) => {
        // Check for role
        return (state.AppActiveUser.roles.includes(role));
    }
}
